<template>
  <el-switch
    v-model="isDark"
    active-text="暗黑模式"
    inactive-text="明亮模式"
    active-color="#409eff"
    inactive-color="#909399"
    @change="toggleTheme"
  />
</template>

<script>
export default {
  name: 'ThemeSwitch',
  data() {
    return {
      isDark: false // 默认明亮模式
    }
  },
  mounted() {
    // 初始化：从本地存储读取用户上次选择的模式
    const theme = localStorage.getItem('element-theme') || 'light'
    this.isDark = theme === 'dark'
    this.setTheme(theme)
  },
  methods: {
    // 切换主题
    toggleTheme(checked) {
      const theme = checked ? 'dark' : 'light'
      this.setTheme(theme)
      // 持久化存储
      localStorage.setItem('element-theme', theme)
    },
    // 设置主题样式
    setTheme(theme) {
      if (theme === 'dark') {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
    }
  }
}
</script>